import { render, staticRenderFns } from "./YaJinBuJiao.vue?vue&type=template&id=53a54a94&scoped=true"
import script from "./YaJinBuJiao.vue?vue&type=script&lang=js"
export * from "./YaJinBuJiao.vue?vue&type=script&lang=js"
import style0 from "./YaJinBuJiao.vue?vue&type=style&index=0&id=53a54a94&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53a54a94",
  null
  
)

export default component.exports